import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Tooltip } from '@mui/material';
import { Check as CheckIcon, DoNotDisturb as DoNotDisturbIcon, ContentCopy as ContentCopyIcon } from '@mui/icons-material';

import { useTrans } from "~/hooks/useTrans";
import { KEY_PREVIEW_LENGTH } from "~/const";
import { IClientKey } from "~/providers/client-interfaces";
import { IAdminKey } from "~/providers/admin-interfaces";
import { notificationStore } from "~/stores/notification";

interface IKeysTableInfo {
	items: Array<IClientKey | IAdminKey>;
	bottomRow: string;
}

export default function KeysTableInfo({
	items = [],
	bottomRow = "",
}: IKeysTableInfo) {
	const { trans } = useTrans();
	const { setNotification } = notificationStore(notificationState => ({
		setNotification: notificationState.setNotification,
	}));
	const HEADERS = [
		"apiKeyId",
		"usersPage.tableState",
		"apiKey",
		"",
	];

	function onCopy(apiKey: string) {
		navigator.clipboard.writeText(apiKey);
		setNotification(trans("keyCopiedToClipboard"));
	}

	/* eslint-disable no-magic-numbers */
	return <TableContainer component={Paper}>
		<Table aria-label="table">
			<TableHead>
				<TableRow>
					{ HEADERS.map(header => <TableCell sx={{ fontWeight: "bold" }} key={header}>
						{ header && trans(header) }
					</TableCell>) }
				</TableRow>
			</TableHead>
			<TableBody>
				{ items.map(keyData => (<TableRow key={keyData.id}>
					<TableCell>
						{ keyData.internalName }
					</TableCell>
					<TableCell>
						<Tooltip title={keyData.forbiddenConsumptionReason}>
							{ keyData.canConsume
								? <CheckIcon sx={{ fill: "var(--dark-green-text-color)" }} />
								: <DoNotDisturbIcon sx={{ fill: "var(--red-text-color)" }} /> }
						</Tooltip>
					</TableCell>
					<TableCell>
						<span style={{ marginRight: "5px", background: "var(--key-background)", borderRadius: "10px", padding: "4px 10px" }}>
							{keyData.apiKey.slice(0, KEY_PREVIEW_LENGTH)}...
						</span>
					</TableCell>
					<TableCell>
						<div style={{ display: "flex", gap: "var(--margin-small)", justifyContent: "flex-end", alignItems: "center" }}>
							<Button onClick={() => onCopy(keyData.apiKey)}>
								<ContentCopyIcon />
							</Button>
						</div>
					</TableCell>
				</TableRow>)) }
				{ bottomRow && <TableRow>
					<TableCell colSpan={HEADERS.length} sx={{ textAlign: "center" }}>
						{ bottomRow }
					</TableCell>
				</TableRow> }
			</TableBody>
		</Table>
	</TableContainer>;
}
